/**
 * This is a generic class to support webSockets with configuration
 * @param configuration
 * @returns {{configure: configure, send: send, restartSocket: restartSocket}}
 * Configuration object can include the following:
 * server - location of the server location, mandatory
 * autoReConnect: true - if to try and reconnect on socket disconnect, optional
 * reconnectTimeout : 2000, - how many seconds before socket reconnect attempts, optional
 * maxReconnectAttempt : 30 - how many times we try to reconnect before giving up the socket, optional
 * message - a callback for every incoming message
 * created - a callback to be called every time a socket is created
 * closed - a callback to be called every time a socket is closed
 * ping - { //A ping object to allow validating the service is alive
 *       request : {} || '', //A string or object that will be sent periodically, Required
 *       response : '' //An expected string response, Optional
 *      }
 * idleBeforePing - time before we ping the socket, default is 10 seconds
 */
window.lpTag = window.lpTag || {};
lpTag.taglets = lpTag.taglets || {};
lpTag.taglets.LPWebSocketWrapper = lpTag.taglets.LPWebSocketWrapper || function LPWebSocketWrapper(configuration) {

        var name = "LPWebSocketWrapper",
            version = "0.9.8",
            supported = typeof window.WebSocket !== "undefined" && //Validate it exists on the window object
                (('' + window.WebSocket).indexOf("[native") > -1 || //Validate it's not a polyfill - Chrome, Firefox, IE10+
                ('' + window.WebSocket).indexOf("WebSocketConstructor") > -1),//Validate it's not a pollyfill - Safari
            socketInstance,
            pingEnabled = false,
            awaitingPingResponse = false,
            pingTimeout,
            reconnectTimeout,
//       errorCodes = {
//            NORMAL: 1000,
//            GOING_AWAY: 1001,
//            PROTOCOL_ERROR: 1002,
//            UNSUPPORTED_DATA: 1003,
//            NO_STATUS: 1005,
//            ABNORMAL: 1006,
//            INVALID_PAYLOAD: 1007,
//            POLICY_VIOLATION: 1008,
//            MESSAGE_TOO_BIG: 1009,
//            MANDATORY_EXT: 1010,
//            INTERNAL_SERVER_ERROR: 1011,
//            TLS_HANDSHAKE: 1015
//        },
            connected = false,
            socketUrl,
            socketOpenCallbacks = [],
            socketMessageCallbacks = [],
            socketClosedCallbacks = [],
            pingTimeoutsCallbacks = [],
            concurrentConnectionErrorCount = 0,
            reconnectScaling = [
                {count: 5, timeout: 2000},
                {count: 20, timeout: 5000},
                {timeout: 10000}
            ],
            pingObject = {},
            defaults = {
                autoReconnect: true,
                reconnectTimeout: 2000,
                maxReconnectAttempt: 100,
                idleBeforePing: 10000,
                pingTimeout : 30000
            },
            logType = {DEBUG: "DEBUG", INFO: "INFO", ERROR: "ERROR"};

        /************************ Invocation **********************************/

        configure(configuration);

        /************************ Public METHODS **********************************/

        function init() {}

        /**
         * Allows setting configuration options
         * @param configuration - object can contain:
         * server - location of the server
         * autoReconnect: true - if to try and reconnect on socket disconnect
         * reconnectTimeout : 2000, - how many seconds before socket reconnect attempts
         * maxReconnectAttempt : 30 - how many times we try to reconnect before giving up the socket
         * message - a callback for every incoming message
         * created - a callback to be called every time a socket is created
         * closed - a callback to be called every time a socket is closed
         * ping - { //A ping object to allow validating the service is alive
     *   request : {} || '', //A string or object that will be sent periodically, Required
     *   response : '' //An expected string response, Optional
     *  }
         * idleBeforePing - time before we ping the socket, default is 10 seconds
         */
        function configure(configuration) {
            if (configuration) {
                if (!connected && typeof  configuration.server === 'string') {//This should happen if we don't have a configured, active web socket only
                    if (configuration.server.indexOf("ws") === 0) {
                        socketUrl = configuration.server;           //and due to quirks in the way different networks handle this protocol we only allow WSS
                    }
                }

                if (typeof configuration.created === 'function') {
                    socketOpenCallbacks.push({cb: configuration.created, context: configuration.context});
                }

                if (typeof configuration.message === 'function') {
                    socketMessageCallbacks.push({cb: configuration.message, context: configuration.context});
                }

                if (typeof configuration.closed === 'function') {
                    socketClosedCallbacks.push({cb: configuration.closed, context: configuration.context});
                }
                if (typeof configuration.ping === 'object') {
                    _pingSetup(configuration.ping);
                }

                if (socketUrl) {
                    for (var key in defaults) {
                        if (defaults.hasOwnProperty(key)) {
                            if (typeof configuration[key] === typeof defaults[key]) {
                                defaults[key] = configuration[key];
                            }
                        }
                    }
                    if (connected) {
                        return true;
                    } else {
                        return _createSocket(defaults);
                    }
                }
            }
        }

        /**
         * Restarts the socket connection after multiple failed attempts
         * @returns {boolean}
         */
        function restartSocket() {
            var socketRestarted = false;
            if (!socketInstance) {
                concurrentConnectionErrorCount = 0;//Reset the counter so we can auto retry the socket
                socketRestarted = _createSocket();
            } else {
                socketRestarted = connected;
            }
            return socketRestarted;
        }

        /**
         * Returns the current socket state
         * @returns {boolean}
         */
        function isConnected() {
            return connected;
        }

        /**
         * Sends a string over the socket
         * @param request
         */
        function send(request) {
            var reqStr = 'N/A';
            try {
                reqStr = _stringify(request);
                if (isConnected()) {
                    _schedulePingRequest();
                    socketInstance.send(reqStr);
                } else {
                    _error("Socket not connected. [request=" + reqStr + "]", "send");
                }
            } catch (exc) {
                _error("Unable to send request [exc=" + (exc.message || exc) + ", request=" + reqStr + "]", "send");
            }
        }

        /**
         * Clears the socket connection and socket
         */
        function dispose() {
            clearTimeout(reconnectTimeout);
            clearTimeout(pingTimeout);
            socketUrl = '';
            _disconnect();
            socketOpenCallbacks.length = 0;
            socketMessageCallbacks.length = 0;
            socketClosedCallbacks.length = 0;
            pingTimeoutsCallbacks.length = 0;
        }

        /************************ PRIVATE METHODS **********************************/

        /**
         * Sets up the ping behavior in the transport layer
         * @param pingOptions
         * @private
         */
        function _pingSetup(pingOptions) {

            if (typeof  pingOptions === 'object') {
                if (pingOptions.request) { //This is a must, otherwise we can't ping
                    pingObject.request = JSON.parse(_stringify(pingOptions.request));
                    pingEnabled = true;

                    if(pingOptions.response){
                        pingObject.response = pingOptions.response;
                    }else if (typeof pingOptions.keys === 'object' && //This is if we can set keys we check on requests
                        typeof pingObject.request === 'object' &&
                        typeof pingOptions.keys.request === 'string' &&
                        typeof pingOptions.keys.response === 'string') {
                        pingObject.reqKey = pingOptions.keys.request;
                        pingObject.resKey = pingOptions.keys.response;
                    }

                    if(typeof pingOptions.callback === 'function'){
                        pingTimeoutsCallbacks.push({cb : pingOptions.callback });
                    }

                    if(pingObject.response ||
                        (pingObject.reqKey  && pingObject.resKey )) { //Only set ping timeouts in case we know how to test for ping
                        pingObject.timeout = pingOptions.timeout || defaults.pingTimeout;
                    }
                    pingObject.idleBeforePing = pingOptions.idleBeforePing|| defaults.idleBeforePing;
                }
            }
        }

        /**
         * Method for logging
         * @param msg
         * @param type
         * @param callingMethod
         */
        function _log(msg, type, callingMethod) {
            if (window.lpTag && lpTag.log) {
                if (typeof msg === 'string' && callingMethod) {
                    msg = callingMethod + ': ' + msg;
                }
                lpTag.log(msg, type, name);
            }
        }

        /**
         * Shorthand for error logs
         * @param msg
         * @param methodName
         * @private
         */
        function _error(msg, methodName) {
            _log(msg, logType.ERROR, methodName);
        }

        /**
         * Shorthand for debug logs
         * @param msg
         * @param methodName
         * @private
         */
        function _debug(msg, methodName) {
            _log(msg, logType.DEBUG, methodName);
        }

        /**
         * Shorthand for info logs
         * @param msg
         * @param methodName
         * @private
         */
        function _info(msg, methodName) {
            _log(msg, logType.INFO, methodName);
        }

        /**
         * Tries to re-establish a connection once the
         * socket has been killed for any reason
         */
        function _reconnectSocket() {

            if (concurrentConnectionErrorCount >= defaults.maxReconnectAttempt) {
                _runCallbacks("cb", socketClosedCallbacks, {
                    state: "TERMINAL",
                    code: 503,
                    message: "Socket terminal, will not reconnect"
                });
            } else if (defaults.autoReconnect && socketUrl) {
                if (reconnectTimeout) {
                    clearTimeout(reconnectTimeout);
                }
                reconnectTimeout = setTimeout(function () {
                    if (!_createSocket()) {
                        concurrentConnectionErrorCount = concurrentConnectionErrorCount + 1;
                        _reconnectSocket();
                    }
                }, _getReconnectTimeout());
            }
        }

        /**
         * Function to get the timeout to reconnect
         * @private
         */
        function _getReconnectTimeout() {
            var timeout;
            if (concurrentConnectionErrorCount < reconnectScaling[0].count) {
                timeout = defaults.reconnectTimeout || reconnectScaling[0].timeout;
            } else if (concurrentConnectionErrorCount < reconnectScaling[1].count) {
                timeout = reconnectScaling[1].timeout;
            } else {
                timeout = reconnectScaling[2].timeout;
            }
            return timeout;
        }

        /**
         * Creates a singleton web socket
         * @param config
         * @returns {boolean}
         * @private
         */
        function _createSocket(config) {
            var socketCreated = false;
            socketUrl = (config && config.server) || socketUrl;
            if (!socketInstance && socketUrl && navigator.onLine === true) {
                try {
                    socketInstance = new WebSocket(socketUrl);
                } catch (exc) {
                    _error("Exception creating WebSocket: " + exc.message, "_createSocket");
                    socketInstance = null;
                }
                if (socketInstance && socketInstance.readyState <= 3) {
                    _bindSocketCallbacks();
                    socketCreated = true;
                }
            }
            return socketCreated;
        }

        /**
         * Function to bind callbacks to the socket events
         * @private
         */
        function _bindSocketCallbacks() {
            if (socketInstance && typeof socketInstance.onopen !== 'function') {
                socketInstance.onopen = _socketOpened;
                socketInstance.onclose = _socketClosed;
                socketInstance.onerror = _socketError;
                socketInstance.onmessage = _socketMessage;
            }
        }

        /**
         * Function to unbind callbacks from the socket events
         * @private
         */
        function _unbindSocketCallbacks() {
            if (socketInstance) {
                socketInstance.onopen = null;
                socketInstance.onclose = null;
                socketInstance.onerror = null;
                socketInstance.onmessage = null;
            }
        }

        /**
         * Function to set socket open state
         */
        function _socketOpened(message) {
            connected = true;
            concurrentConnectionErrorCount = 0;
            _runCallbacks("cb", socketOpenCallbacks, _parseSocketData(message) || {state: "OPEN", code: 200});
        }

        /**
         * Handles messages coming across the pipe
         * @param message
         * @private
         */
        function _socketMessage(message) {//body, statusCode,
            var isPingMessage = false;

            if (message) {
                try {
                    var parsedMessage = transformToJSON(message.data);
                    if (awaitingPingResponse) {
                        isPingMessage = _handlePingResponse(parsedMessage);
                    }
                    _schedulePingRequest();
                    if(!isPingMessage) {
                        _runCallbacks("cb", socketMessageCallbacks, parsedMessage);
                    }

                } catch (exc) {
                    _error("failed to process message", "_socketMessage");
                }
            }
        }

        /**
         * Attempts to parse the data into JSON
         * @param data
         * @returns {*}
         */
        function transformToJSON(data) {
            var res = data;
            try {
                res = JSON.parse(data);
            } catch (exc) {
                _error("Unable to parse message", "transformToJSON");
            }
            return res;
        }

        /**
         * Called when the socket is closed
         * @private
         */
        function _socketClosed(message, error) {
            connected = false;
            _dumpSocket();
            _runCallbacks("cb", socketClosedCallbacks, _parseSocketData(message, error) || {
                    state: "CLOSED",
                    code: 500
                });
            _reconnectSocket();
        }


        /**
         * Disconnects the socket or stops the retry mechanism
         */
        function _disconnect() {
            defaults.autoReconnect = false;

            if (connected) {
                socketInstance.close();
                connected = false;
            }
            _dumpSocket();
        }

        /**
         * Parses response codes from the socket
         * state change event
         * @param data
         * @param error
         * @returns {*}
         * @private
         */
        function _parseSocketData(data, error) {
            if (data) {
                return {
                    name: name,
                    state: data.type,
                    code: data.code,
                    statusCode: data.code > 1000 || error ? 500 : 200,
                    reason: data.reason || "",
                    domain: (data.srcElement && data.srcElement.url) ? data.srcElement.url : ""
                };
            } else {
                return null;
            }
        }

        /**
         * Masks running a single response as opposed
         * to an array of responses
         * @param type
         * @param request
         * @param data
         * @private
         */
        function _runCallbacks(type, request, data) {
            var requestsArray;
            if (request) {
                requestsArray = request.constructor === Array ? request : [request];
                for (var i = 0; i < requestsArray.length; i++) {
                    _runCallback(requestsArray[i][type], data, requestsArray[i].context);
                }
            }
            requestsArray = null;
        }

        /**
         * Wrapped method for executing call backs
         * @param cb
         * @param data
         * @param context
         * @private
         */
        function _runCallback(cb, data, context) {
            if (typeof cb === 'function') {
                try {
                    cb.call(context || null, data);
                } catch (exc) {
                    _error("Error executing callback", "_runCallback");
                }
            }
        }

        /**
         * This function was added because of incompatibility between the JSON.stringify and Prototype.js library
         * When a costumer uses Prototype.js library, It overrides the Array.prototype.toJSON function the the native JSON
         * uses. This causes arrays to be double quoted and Shark to fail on those SDEs.
         * The function accepts a value and and uses the native JSON.stringify
         * Can throw an exception (same as JSON.stringify).
         */
        function _stringify(value) {
            var stringified;
            if (typeof Array.prototype.toJSON === 'function') {
                var toJSONPrototype = Array.prototype.toJSON;
                delete Array.prototype.toJSON;
                try {
                    stringified = JSON.stringify(value);
                } catch (e) {
                    Array.prototype.toJSON = toJSONPrototype;
                    throw e;
                }
                Array.prototype.toJSON = toJSONPrototype;
            } else {
                stringified = JSON.stringify(value);
            }
            return stringified;
        }

        /**
         * Schedules when we need to ping the service to make sure
         * our connection isn't killed by the server application and verify it's still
         * really connected
         * @private
         */
        function _schedulePingRequest() {
            if (pingEnabled && !awaitingPingResponse) {
                _clearScheduledPing();
                pingObject.timeoutId = setTimeout(_sendPing, pingObject.idleBeforePing);
            }
        }

        /**
         * Clears the scheduled ping request
         * @private
         */
        function _clearScheduledPing(){
            if (pingObject.timeoutId) {
                clearTimeout(pingObject.timeoutId);
                pingObject.timeoutId = null;
            }
        }

        /**
         * Sends a ping message to the server since there
         * was not traffic observed in the defined timeout period
         * @private
         */
        function _sendPing() {
            if (pingEnabled && !awaitingPingResponse) {
                awaitingPingResponse = true;
                send(_buildPingMessage(), true);
                if(pingObject.timeout) {
                    pingTimeout = setTimeout(_pingTimeout, pingObject.timeout);
                }
            }
        }

        /**
         * Callback when ping times out
         * @private
         */
        function _pingTimeout(){
            awaitingPingResponse = false;
            _runCallbacks("cb", pingTimeoutsCallbacks, {
                state: "TIMEOUT",
                code: 404,
                message: "No Ping Response from Service"
            });

            delete pingObject.timeoutId;
            _schedulePingRequest();
        }

        /**
         * Enhances ping request in cases where
         * ids for request and response keys have been defined
         * @returns {desired.dependencies.request|{version, from, resolved}|string|expected.dependencies.request|string|*}
         * @private
         */
        function _buildPingMessage() {
            var pingMessage;

            if (pingObject.request) {
                pingMessage = JSON.parse(_stringify(pingObject.request));
                if(pingObject.reqKey && typeof pingMessage === 'object') {
                    pingObject.lastKey = "pingKey_" + (Math.floor(Math.random() * 99999999));
                    pingMessage[pingObject.reqKey] = pingObject.lastKey;
                }
            }
            return pingMessage;
        }

        /**
         * Handles pings responses from the server
         * @param message
         * @private
         */
        function _handlePingResponse(message){
            if(pingObject.response || (pingObject.reqKey  && pingObject.resKey )){
                if(pingObject.response){
                    if(message === pingObject.response){
                        awaitingPingResponse = false;
                    }
                }else if(typeof message === 'object' &&
                    message[pingObject.resKey] === pingObject.lastKey){
                    awaitingPingResponse = false;
                }

                if(!awaitingPingResponse && pingTimeout) {
                    clearTimeout(pingTimeout);
                    pingTimeout = null;
                }

                    _runCallbacks("cb", pingTimeoutsCallbacks, {
                    state: "PING_SUCCESS",
                        code: 200,
                        message: "Ping Response"
                    });
            }
            return !awaitingPingResponse;
        }

        /**
         * Called when a socket error occurs
         * @private
         */
        function _socketError(message) {
            _socketClosed(message, true);
            concurrentConnectionErrorCount = concurrentConnectionErrorCount + 1;
        }

        /**
         * Clears the socket
         * @private
         */
        function _dumpSocket() {
            _unbindSocketCallbacks();
            _clearScheduledPing();
            socketInstance = null;
        }

        function socketNotSupported() {
            var msg = "WebSocket is not supported here.";
            _error(msg, "socketNotSupported");
            return msg;
        }

        return {
            name: name,
            v: version,
            init: init,
            dispose: dispose,
            supported: supported,
            connected: isConnected,
            configure: supported ? configure : socketNotSupported,
            send: supported ? send : socketNotSupported,
            restartSocket: supported ? restartSocket : socketNotSupported
        };
    };
